/* eslint-disable import/prefer-default-export */
export const LABELS = {
  WELCOME: 'Welcome',
  WELCOME_SUBTITLE: 'You are applying for this property',
  SIGN_IN_TEXT: 'Please sign in to submit your referral to The property collective',
  FORGOT_VIEW: 'Reset your password, to access your account and continue your application.',
  VERIFY_VIEW: 'Check your email to verify your account and continue your application.',
};
